export default __webpack_public_path__ + "static/media/lock.d348a0c7.png";